import { injectable, inject } from 'inversify';
import type { IPanelFacturacionRepository } from '@/domain/repositories/IPanelFacturacionRepository';
import { PanelFacturacion } from '@/domain/entities/PanelFacturacion';
import { TYPES } from '@/di/tokens';

@injectable()
export class ListBillingPanelsAction {
  constructor(
    @inject(TYPES.IPanelFacturacionRepository) private billingRepository: IPanelFacturacionRepository
  ) {}

  async execute(pageNumber?: number, pageSize?: number): Promise<PanelFacturacion[]> {
    return await this.billingRepository.getAll(pageNumber, pageSize);
  }
}
